
import * as demoApi from './api/DemoApiService';
import * as prodApi from './api/ProductionBarApiService'

const ApiService = process.env.REACT_APP_DEMO
    ? demoApi
    : prodApi;
export default ApiService;
